<template>
  <div>
    <b-modal id="modal-profile" ref="modalProfile" title="Perfil de usuario" size="lg" hide-footer>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-row>
          <b-col lg="4" sm="6">
            <b-form-group>
              <label>Nombre</label>
              <b-form-input type="text" v-model="user.name" readonly />
            </b-form-group>
          </b-col>

          <b-col lg="4" sm="6">
            <b-form-group>
              <label>Apellido</label>
              <b-form-input type="text" v-model="user.lastName" readonly />
            </b-form-group>
          </b-col>

          <b-col lg="4" sm="6">
            <b-form-group>
              <label>Genero</label>
              <b-form-input type="text" v-model="user.genre" readonly />
            </b-form-group>
          </b-col>

          <b-col lg="4" sm="6">
            <b-form-group>
              <label>Fecha Nacimiento</label>
              <b-form-input type="text" v-model="user.dateBorn" readonly />
            </b-form-group>
          </b-col>

          <b-col lg="4" sm="6">
            <b-form-group>
              <label>Documento</label>
              <b-form-input type="text" v-model="user.documentNumber" readonly />
            </b-form-group>
          </b-col>

          <b-col lg="4" sm="6">
            <b-form-group>
              <label>RH</label>
              <b-form-input type="text" v-model="user.rh" readonly />
            </b-form-group>
          </b-col>

          <b-col lg="4" sm="6">
            <b-form-group>
              <label>Telefono</label>
              <b-form-input type="text" v-model="user.telephone" readonly />
            </b-form-group>
          </b-col>

          <b-col lg="4" sm="6">
            <b-form-group>
              <label>Email</label>
              <b-form-input type="email" v-model="user.email" readonly />
            </b-form-group>
          </b-col>

          <b-col lg="4" sm="6">
            <b-form-group>
              <label>Registro Médico</label>
              <b-form-input type="text" v-model="user.medicalRegister" readonly />
            </b-form-group>
          </b-col>

          <b-col lg="4" sm="6">
            <b-form-group>
              <label>Especialidad</label>
              <b-form-input type="text" v-model="user.specialty" readonly />
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ProfileUser",
  data() {
    return {
      user: {
        name: "",
        lastName: "",
        genre: "",
        dateBorn: "",
        typeDocument: "",
        documentNumber: "",
        telephone: "",
        rh: "",
        medicalRegister: "",
        specialty: "",
        userName: "",
        email: "",
        rol: ""
      }
    };
  },
  mounted() {
    this.axios
      .get(this.$apiURI_users + "/api/v1/users/" + this.$store.getters.userId)
      .then(response => {
        this.user.name = response.data.first_name;
        this.user.lastName = response.data.last_name;
        this.user.genre =
          response.data.gender == "F" ? "Femenino" : "Masculino";
        this.user.dateBorn = response.data.birth_date;

        this.user.documentNumber =
          response.data.type_document.description.replace(/\s/g, "") +
          " " +
          response.data.documen;
        this.user.telephone = response.data.phone_number;
        this.user.rh = response.data.rh.description;
        this.user.medicalRegister = response.data.medical_record;        
        this.user.userName = response.data.username;
        this.user.email = response.data.email;
        this.user.rol = response.data.roles;

        var specialitys = [];
        (response.data.specialtis).forEach(element => {          
          specialitys.push(element.description)        
        });
        this.user.specialty = specialitys.toString();

      });
  }
};
</script>


// WEBPACK FOOTER //
// src/layouts/showProfile.vue